class WishlistSaveList extends window.BAO.CustomElement() {
  async connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.saveList = this.saveList.bind(this)
    this.listeners.add(this, 'click', this.saveList)
  }

  async saveList (e) {
    e.preventDefault()

    if (!this.token) {
      window.location.href = `/account/login?next=${encodeURIComponent(
        this.listUrl,
      )}`
      return
    }

    await window.BAO.wishlist.saveList(this.listId, this.token)

    window.location.reload()
  }

  get listId () {
    return this.dataset.listId
  }

  get token () {
    return window.BAO.wishlist.token
  }

  get listUrl () {
    return `${window.theme.appSettings.proxyUrl}/lists/${this.listId}`
  }
}

customElements.define('wishlist-save-list', WishlistSaveList)
